import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import createXssFilter from '../../../store/createXssFilter';
import { sendEcommerceEvent } from '../../../components/GA4';

const defaultProps = {
  title: Drupal.t('roomName missing'),
};

const AccommodationSearchResult = (properties) => {
  const props = {
    ...defaultProps,
    ...properties,
  };

  const [ownerInfoOpen, setOwnerInfoOpen] = useState(false);
  const xssFilter = createXssFilter();
  const dataLayer = window.dataLayer;

  const handleBooking = () => {
    sendEcommerceEvent(
      dataLayer,
      'select_item',
      true,
      props.roomName,
      props.price,
      props.departmentName,
      props.housingType
    );
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      {props.hasOwnership && (
        <>
          <button
            className="accommodation-search__result__ownership"
            onClick={() => setOwnerInfoOpen(ownerInfoOpen ? false : true)}
          >
            <div className="accommodation-search__result__home-icon"></div>
            {Drupal.t('Ski-Inn® owner')}
            <div
              className={`accommodation-search__result__arrow-icon ${
                ownerInfoOpen
                  ? 'accommodation-search__result__arrow-icon--open'
                  : ''
              }`}
            ></div>
          </button>
          {ownerInfoOpen && (
            <div className="accommodation-search__result__ownership-info">
              {drupalSettings.ski_inn_ownership_info}
            </div>
          )}
        </>
      )}
      <div className="accommodation-search__result">
        {props.images ? (
          <div className="accommodation-search__result__image-wrapper">
            <Slider {...sliderSettings}>
              {props.images.map(
                (image, i) =>
                  image.url && (
                    <img
                      key={i}
                      src={image.url}
                      alt={
                        image.description[drupalSettings.path.currentLanguage]
                      }
                    />
                  )
              )}
            </Slider>
          </div>
        ) : null}
        <div className="accommodation-search__result__content-wrapper">
          <div className="accommodation-search__result__header">
            <div>
              <h4>{props.title}</h4>
            </div>
            {!props.hasOwnership && (
              <div className="accommodation-search__result__price">
                {props.price ? `${props.price} €` : null}
              </div>
            )}
          </div>
          {props.description ? (
            <div
              dangerouslySetInnerHTML={{ __html: xssFilter(props.description) }}
            />
          ) : null}
          <div className="accommodation-search__result__specs-wrapper">
            <ul className="accommodation-search__result__specs-list">
              {props.area ? <li>{props.area}m²</li> : null}
              <li>
                {props.beds} {Drupal.t('beds')}
              </li>
            </ul>
            <ul className="accommodation-search__result__specs-list">
              {props.lift_distance ? (
                <li>
                  {props.lift_distance} m {Drupal.t('to lift')}
                </li>
              ) : null}
              {props.skitrail_distance ? (
                <li>
                  {props.skitrail_distance} m {Drupal.t('to trail')}
                </li>
              ) : null}
              {props.village_distance || props.village_distance === 0 ? (
                <li>
                  {props.village_distance} m {Drupal.t('to village')}
                </li>
              ) : null}
            </ul>
          </div>
          <a
            href={`${drupalSettings.base_url}/${drupalSettings.path.currentLanguage}/product/${props.product_id}?${props.productParams}`}
            className="button button--large-full-width"
            onClick={() => handleBooking()}
          >
            {props.hasOwnership
              ? Drupal.t('Make booking request')
              : Drupal.t(
                  'Start booking',
                  {},
                  { context: 'Accommodation search' }
                )}
          </a>
        </div>
      </div>
    </>
  );
};

AccommodationSearchResult.propTypes = {
  id: PropTypes.number,
  product_id: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  images: PropTypes.array,
  area: PropTypes.number,
  beds: PropTypes.string,
  village_distance: PropTypes.number,
  lift_distance: PropTypes.number,
  skitrail_distance: PropTypes.number,
  price: PropTypes.string,
  productParams: PropTypes.string,
  hasOwnership: PropTypes.bool,
  departmentName: PropTypes.object,
  housingType: PropTypes.object,
  roomName: PropTypes.string,
};

export default AccommodationSearchResult;
